module.exports = __webpack_public_path__ + "img/reasons_to_invest.71801413.png";